<div class="flex flex-col px-10 py-4 border-2 border-gray-900/10 rounded-md"
    [ngClass]="error ? 'border-red-500' : 'border-gray-900/10'">
    <div class="text-lg font-semibold my-1">{{ title }}</div>

    @if (preview) {
        <div class="flex flex-col gap-2 text-md">
            <div><span class="font-semibold">Ulica:</span> {{ currentValue.street || '-' }}</div>
            <div><span class="font-semibold">Kućni broj:</span> {{ currentValue.streetNumber || '-' }}</div>
            <div><span class="font-semibold">Grad:</span> {{ currentValue.city || '-' }}</div>
            <div><span class="font-semibold">Poštanski broj:</span> {{ currentValue.postalCode || '-' }}</div>
        </div>
    } @else {
        <div class="w-1/3">
            <div class="mb-2">
                Ulica:
                <input class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                    [(ngModel)]="currentValue.street" type="text" (keyup)="update(currentValue)" />
            </div>

            <div class="mb-2">
                Kućni broj:
                <input class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                    [(ngModel)]="currentValue.streetNumber" type="text" (keyup)="update(currentValue)" />
            </div>

            <div class="mb-2">
                Grad:
                <input class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                    [(ngModel)]="currentValue.city" type="text" (keyup)="update(currentValue)" />
            </div>

            <div class="mb-2">
                Poštanski broj:
                <input class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                    [ngModel]="currentValue.postalCode" type="text" (input)="onlyNumbers($event)" />
            </div>

            @if (!isNumberOrEmpty) {
                <div class="py-2 px-1 text-red-500 font-semibold">
                    *Molimo unesite samo brojeve
                </div>
            }
        </div>
    }
</div>
